module.exports = __webpack_public_path__ + "static/item-1-8b929915439a8d1ce388da6f91488118.jpeg";